export default {
  locale_name: '日本語',
  facebook: 'フェイスブック',
  twitter: 'ツイッター',
  insta: 'インスタグラム',
  telegram: 'テレグラム',
  buy: '購入する',
  sell: '売却する',
  login: 'ログイン',
  sign_up: '会員登録',
  profile: 'マイページ',
  logout: 'ログアウト',
  home: 'ホーム',
  asset: '資産',
  code: 'コード',
  buy_btn: '購入',
  not_allow: '不可',
  sell_btn: '売却',
  trade: '取引',
  select: '選択',
  cancel: 'キャンセル',
  deposit: '入金',
  withdraw: '出金',
  request: '申請',
  account: '口座',
  status: '状態',
  allow: '許可',
  disallowed: '非許可',
  modify: '修正',
  auto: '(自動入力)',
  inquiry: '照会',
  no_select: '(選択なし)',
  confirm: '確認',
  upload_btn: 'ここにファイルをドロップするか、クリックしてください。',
  continue_entry: '続ける場合は "[+:verification]"を 下に入力してください。',
  toasted_msg: {
    confirm: '確認されました。',
    changed: '変更されました。',
    withdrawal: '退会されました。',
    register: '登録されました。',
    title: 'お知らせ',
    exchange: 'ダイレクト両替が成功的に処理されました。',
    search: '照会されました。',
    deposit_request: '入金申請されました。',
    withdraw_request: '出金申請されました。',
    create_account: '開設されました。',
    modify: '修正されました。',
    cancel: 'キャンセルされました。',
    trade_confirm: '取引きが確定されました。',
    trade_reject: '取引きが拒否されました。',
    copy: 'コピーされました。',
    nice_msg:
      'ブラウザー設定のポップアップが許可になっていない場合、本人確認が正常的に行えません。',
    nice_title: '案内',
    nice_error: '本人確認ができません。',
    no_transfer: '両替情報がありません。',
    email_auth: 'Eメール認証が成功的に完了されました。',
    email_auth_send: '認証メールが発送されました。',
    kyc_withdraw: '口座認証に成功しました。',
    not_allow_trade: '取引き非活性化状態です。',
  },
  header: {
    C2C_enroll: 'C2C 登録',
    direct_buy: '購入する',
    direct_sell: '売却する',
    wallet_manage: 'ウォレット管理',
    C2C_list: 'C2C内訳',
    B2C_list: 'B2C内訳',
    withdrawal: '入/出金',
    trade_list: '取引き内訳',
    customer_service: 'カスタマーセンター',
  },
  home_msg: {
    about_title: 'ABOUT RMT',
    about_title_2: '韓国ブロックチェイン産業の発展、RMTがご一緒します。',
    about_line_1_1:
      '暗号資産を実質的な現物の交換及び仲介所形態の新しい概念の暗号資産仲介所',
    about_line_1_2: '検証済みの暗号資産を厳選し上場',
    about_line_1_3: '多様な言語に対応するグローバル暗号資産仲介所',
    about_line_2_1:
      '大規模分散型アーキテクチャ設計及び DDOS 攻撃防御システムを元に安心できるセキュリティ性',
    about_line_2_2: '安定的な取引き環境及び資産補完管理ソリューション提供',
    about_line_3_1: '独自のネットワークを通じて決済及び取引き安定性確保',
    about_line_3_2: 'お客様と信頼関係を構築し、定期的なサービスアップデート',
    about_line_4_1:
      'オンラインとオフラインの制約なしで暗号化された資産を活用できる様に繋いでくれる統合されたクリプトプラットフォーム',
    about_sub_1: 'ポイント',
    about_sub_1_1:
      'グローバル規制が強化しつつある情勢に合わせて国際機構の FATF (Financial Action Task Forc)と 仮想資産サービス提供社(VASP : virtual Asset Service Providers)の 勧告案によった資金ロンダリング防止とテロ資金調達遮断規定遵守',
    about_sub_1_2:
      '暗号資産保有者達の場外取引き(OTC)の比率が増えていて、信頼できる取引所の信頼性低下に合わせて、C2C B2C の様な クイック取引き提供',
    about_sub_2: '多様なコンテンツ',
    about_sub_2_1:
      'キオスクを活用しオフラインのどこでも使用可能な様に接近性を高めた',
    about_sub_2_2: 'カート型ウォレットを作ることができ、安全性と便利性の極大化',
    about_sub_2_3: 'グローバルオープンマーケットショッピングモール運営',
    about_sub_3: 'グローバルビジョン',
    about_sub_3_1:
      '韓国を越え、中国及び東南アジアサービスと日本、ヨーロッパへとサービス拡散予定',
    about_sub_3_2:
      '国内に導入したキオスク機器をベトナム、フィリピン等、海外に普及し新しい時代を主導するグローバル暗号資産仲介所 RMT',
    about_side_1: '世界を先導する暗号資産取引所',
    about_side_1_1: '迅速で安全に直取引が可能な(C2C) 24時間取引きサービス対応',
    about_side_1_2:
      'エスクローシステムをサービスし、暗号資産取引きの安全性提供',
    about_side_1_3:
      '中間段階なしに RMTを利用し、クイック(Quick)取引きが可能な B2C 対応',
    about_side_1_4:
      'OTC(場外取引)の不便さと手数料負担を減らしてくれ、オフラインでも24時間安全で便利な直取引サービス対応',
    login_register: 'ログイン/会員登録',
    trade_guide: '取引きガイドを見る',
    app_down_1: 'App ダウンロード',
    app_down_2: '様々なコイン、リアルタイム相場、簡単な取引き',
    app_down_3: 'いつどこでも便利な取引きサービスをご利用頂けます。',
  },
  footer: {
    about: '紹介',
    career: '沿革',
    escrow: 'エスクロー取引',
    press: 'マスコミ',
    partner: '私達とパートナーになるには',
    help: 'お客様サポート',
    chat: 'ライブチャット',
    blog: 'ブログ',
    phone: '連絡先',
    social: 'ソーシャル',
  },
  footer_link: {
    about_title: '会社紹介',
    msg_about_1:
      'RMTは Real Money Tradeの略語で、暗号資産仲介所です。グローバル規制が強化しつつある情勢に合わせ 国際機構の FATF (Financial Action Task Force)と 仮想資産サービス提供社 VASP (Virtual Asset Service Providers)の勧告案による資金ロンダリング防止と、テロ資金調達遮断規定を準じており、ご利用者達の円滑の取引きと安全な取引きをサポートしています。 ',
    msg_about_2:
      '暗号資産保有者達は場外取引き(OTC)に重点をおいていて、取引所達の信頼性が低下しつつあります。変化する時代に合わせて RMTは C2C B2Cの様なクイック取引に対応しています。',
    msg_about_3:
      'RMTの ONE CARDはコールドウォレットシステムを結合してネットワークが遮断されたハードウェア装置に暗号資産を保管しオフラインで処理しセキュリティ性が優れています。',
    msg_about_4:
      'ONE CARDは国内に補給されたキオスク機器に使用可能で、オフラインでも RMT 仲介所をご利用できます。',
    msg_about_5:
      'また、キオスク機器は現金引き出し及び入金、映画チケット予約、RMT ショッピングモール等、現実性ある様々なコンテンツをご利用頂けます。',
    msg_about_6:
      'RMTは、英語、中国語、日本語等 様々な言語に対応していて、国内だけでなく、海外までキオスク機器を普及し時代に合った、電子金融トレンドを主導していきます。',
    escrow_big_title: 'エスクロ取引き',
    msg_escrow_1:
      'エスクロサービスとは、売却者と購入者間の取引が安全で円滑に成されるようにしてくれる資産保護サービスです。',
    msg_escrow_2: '-取引き手順-',
    msg_escrow_3:
      '1. 会員が KRWをチャージすると、ウォン貨を銀行(PG社)に保管致します。',
    msg_escrow_4:
      '2. チャージした会員が購入を要請すると、銀行(PG社)へ預けたお金を売却者へ入金します。',
    msg_escrow_5:
      '3. 売却者はお金を, 購入者はコインを確認すると取引きが成立されます。',
    msg_escrow_6:
      '4.問題が発生する場合、双方が提供した証拠に基づき解決を致します。',
    msg_escrow_7: 'RMTは、会員様の資産保護の為努力致します。',
  },
  account_form: {
    id_place: 'IDを入力してください。',
    pw_place: 'パスワードを入力してください。',
    forgot_pw: 'パスワードをお忘れですか？',
    confirm_pw: 'パスワード確認',
    name_place: 'お名前を入力してください。',
    email_place: 'Eメールアドレスを入力してください。',
    agree: '同意します。',
    all_agree: '全て同意します。',
    find_pw: 'パスワードを探す',
    code_place: '発送されたコードを入力してください。',
  },
  trade_page: {
    b2c_trade: 'B2C 取引きする',
    select_asset: '資産を選択してください',
    select_coin: 'コインを選択してください',
    c2c_trade: 'C2C 取引きする',
    buy_asset: '購入する資産',
    sell_asset: '売却する資産',
    purchaser_name: '購入者名',
    seller_name: '売却者名',
    amount: '数量',
    limit_buy: '最低購入数量',
    limit_sell: '最低売却数量',
    total_sell_price: '総売却数量',
    buy_price: '購入価格',
    sell_price: '売却価格',
    regdate: '最終情報修正日',
    sell_register: '売却登録',
    buy_register: '購入登録',
    select_c2c_info: '選択した売渡公示情報',
    seller_info: '売却者情報',
    market_select: 'マーケット選択',
    market_title: 'マーケット名',
    sell_price_msg: '売却しようとする数量 (0.00000000)',
    min_sell_amount: '最低売却数量',
    min_buy_price: '最低購入数量',
    min_sell_amount_msg: '相手の最低購入件数',
    per_sell_price: '件当たり売却価格',
    per_sell_price_msg: '1.00000000 件の指定された価格を決めてください。',
    per_sell_price_msg2: '売却数量 1件当たり受領したい価格で決めてください。',
    select_account: '受け取り口座選択',
    withdraw_account: '出金口座選択',
    direct_buy_asset: 'クイック購入する資産',
    direct_sell_asset: 'クイック売却する資産',
    change_target_asset: '切り替え対象資産',
    source_buy_asset: '購入資産',
    source_sell_asset: '売却資産',
    target_change_asset: '切り替え資産',
    b2c_buy_price: '購入価格',
    b2c_sell_price: '売却価格',
    buy_amount: '購入数量',
    sell_amount: '売却数量',
    buy_amount_msg: '購入しようとする数量 0.00000000',
    per_price: '件当たり価格',
    per_price_msg: '保有 {0} :',
    per_price_msg2: '自動で価格が露出されます。',
    receive_quantity: '受領数量',
    bill_amount: '支払い必要な数量',
    b2c_buy_title: '購入します。',
    b2c_sell_title: '売却します。',
    b2c_asset: '{0} を {1} に',
    b2c_market_price: '現在の為替',
    b2c_direct_buy: 'クイック購入時',
    b2c_direct_sell: 'クイック売却時',
    b2c_exchange_amount: '両替数量',
    b2c_amount: '適用数量',
    b2c_buy: '{0} で購入',
    b2c_sell: '{0} で売却',
    potential_amount: '可用数量',
    holding_amount: '未確定売却数量',
    confirm_amount: '確定売却数量',
  },
  page_navigation: {
    first_page: '開始ページ',
    last_page: '最終ページ',
  },
  wallet: {
    asset_value: '私の KRW 保有量',
    show_currency: '全ての資産を見る',
    asset_list: '資産リスト',
    wallet_list: '口座リスト',
    account_name: '口座名',
    account_number: '口座番号',
    balance: '残高',
    withdrawal_register: '入/出金申請',
    withdrawal_inquiry: '入/出金申請照会',
    account_register: '口座開設',
    deposit_inquiry: '入金照会',
    withdraw_inquiry: '出金照会',
    account_modify: '口座修正',
    deposit_price: '入金金額',
    deposit_register: '入金申請',
    withdraw_register: '出金申請',
    withdraw_price: '出金金額',
    account_seq: '口座固有番号',
    regdate: '開設日',
    hold_balance: '停止金額',
    selected_asset: '選択資産',
    before_regdate: '(開設前)',
    open: '開設',
    address_title: '口座アドレス情報',
    account_address: '口座アドレス',
    create_account_address: '口座アドレス開設',
    deposit_msg: '外部ウォレットから私の {0}ウォレットに {0}を入金します。',
    deposit_msg_1:
      'ブロックチェイン上で 350回の承認(confirm)を得た後 {0} 取引きウォレットに反映されます。',
    deposit_step_1: 'STEP 1. {0} メモ IDを先に確認してください。',
    deposit_step_1_1: '私の {0} メモ ID',
    deposit_step_1_2:
      '{0} 入金時 お客様の固有メモIDを必ず表記しなければいけません。メモ ID なしに送金された {0}は流失されます。',
    deposit_step_1_3: '確認しました。 私の {0} ウォレットアドレスをみます。',
    deposit_step_1_btn: 'メモ ID 生成',
    deposit_step_2: 'STEP 2. 私のウォレットアドレスを確認してください。',
    deposit_step_2_1: 'QR コード',
    deposit_step_2_2: 'ウォレットアドレス',
    deposit_step_2_3:
      '最低入金金額は <span style="color:#4a90e2">{0} {1}</span> です。',
    deposit_step_2_btn: 'ウォレットアドレスコピー',
    deposit_msg_2: '確認してください。',
    deposit_msg_2_1: '上記アドレスは入金専用アドレスです。',
    deposit_msg_2_2:
      '承認完了に所要する総時間はブロックチェインネットワークの混雑度により影響されることもあり、暗号資産別ブロックチェイン混雑度は <span style="color:#4a90e2;cursor:pointer;">ここ</span>で確認可能です。',
  },
  private: {
    my_deal_list: '私の販売リスト',
    my_app_list: '私の購入内訳',
    source_asset: 'ウォン資産',
    target_asset: '対象資産',
    source_amount: 'ウォン資産数量',
    regdate: '公示日',
    source_max_amount: '最大数量',
    source_min_amount: '最低数量',
    max_price: '最大呼値制限',
    min_price: '最低呼値制限',
    close_date: '終了日',
    app_inquiry_cancel: '購入内訳 照会/キャンセル',
    app_name: '買収者名',
    per_price: '数量当たり価格',
    confirm_reject: '確定/拒否',
    confirm: '確定',
    reject: '拒否',
    fee_amount: '手数料合計',
    request_cancel: '申請取り消し',
    b2c_source_asset: '基準資産',
    b2c_target_asset: '相手資産',
    b2c_source_amount: '基準資産数量',
    b2c_target_amount: '相手資産数量',
    basic_rate: '適用売買基準レート',
    spread_rate: '適用スプレッド率',
    exchange_rate: '適用為替',
    source_account: '基準資産口座番号',
    target_account: '相手資産口座番号',
    fee_rate: '手数料',
    fee_calc: '{0} 件分 差し引かれます。',
    b2c_buy_asset: '購入資産',
    b2c_sell_asset: '販売資産',
    b2c_buy_amount: '購入資産数量',
    b2c_sell_amount: '販売資産数量',
    b2c_last_buy_amount: '最終購入価格',
    b2c_last_sell_amount: '最終販売価格',
  },
  withdrawal: {
    deposit_list: '入金申請内訳',
    withdraw_list: '出金申請内訳',
    asset_name: '資産名',
    request_price: '要請金額',
    deposit_inquiry_cancel: '入金内訳 照会/キャンセル',
    withdraw_inquiry_cancel: '出金内訳 照会/キャンセル',
    history_detail: '内訳詳細',
    regdate: '申請日',
  },
  myprofile: {
    profile: '会員情報',
    user_name: 'ユーザー名',
    email: 'Eメール',
    regdate: '登録日',
    last_login: '最近のログイン',
    kyc_cert: 'KYC 認証',
    kyc_cert_request: '認証申請',
    kyc_cert_list: '申請内訳',
    pw_modify: 'パスワード修正',
    old_pw: '既存パスワードを入力してください',
    new_pw: '新しいパスワードを入力してください',
    confirm_pw: 'パスワード確認',
    email_modify: 'Eメール修正',
    new_email: '新しいEメールアドレスを入力してください',
    withdrawal: 'アカウント脱退',
    modal_msg: '脱退するにはパスワードを入力してください',
    authority: '本人認証',
    complete_auth: '認証完了',
    authenticate: '認証する',
    uid: '会員番号(UID)',
    email_auth: 'Eメール認証',
    auth: '認証',
    auth_code_send: '認証コード発送',
    auth_code: '認証コード',
    auth_code_msg: '認証コードを5分以内に入力してください。',
    otp_auth: 'OTP 認証',
    enroll: '登録する',
    security: 'セキュリティレベル',
    security_view: 'セキュリティレベルをみる',
    withdraw_auth: '出金アドレス認証',
  },
  kyc: {
    kyc_title: 'KYC認証',
    regdate: '登録日',
    expdate: '満了日',
    detail: '詳細',
    type_title: 'タイプ名',
    withdraw_auth: '出金アドレス認証',
    select_asset: '資産選択',
    select_bank: '銀行選択',
    holder_name: '口座名義名',
    birth: '生年月日 6桁',
    address: '資産アドレス',
    withdraw_list: '出金口座申請内訳',
    bank_name: '銀行名',
    withdraw_info: '出金口座情報',
    withdraw_complete: 'すでに認証が完了された資産です。',
  },
  otp: {
    enter_verification_number: 'OTP 認証番号を入力してください',
    otp_management: 'OTP管理',
    authenticode: 'OTPキー',
    otp_deactivate: 'OTP非活性化',
    msg_authenticator_installation:
      '"Google Authenticator" アプリをスマートフォン又はデスクトップにインストールしてください',
    android: 'アンドロイド ',
    or: '又は ',
    iphone_series: 'iPhone, iPad そして iPod',
    windows_phone: ' Windows Phone',
    and: ', そして',
    msg_microsoft_other_systems:
      'Microsoft Windows desktopを含むその他のシステム',
    msg_key: 'このキーを ',
    msg_use_loss_change:
      ' 紙に写してください。端末を紛失したり、OTPを変更する時に必要です。',
    msg_brcode_touch:
      '"Google Authenticator" アプリを実行して頂き、画面下の <strong>Scan QR barcode</strong>をタップしてください。',
    msg_input_authenticode:
      '端末の画面に表示された認証コードを下の"認証コード" 欄に入力してください。',
    otp_key: 'OTP キー',
    otp_activate: 'OTP 活性化',
    otp_copy: 'OTP キーがコピーされました。',
    otp_safe_keeping: 'OTPキーを紙に写した後、安全な場所へ保管されましたか？',
    yes: 'はい',
    otp_register: '登録',
    otp_register_success: 'OTP 登録が成功的に完了されました。',
    otp_delete_success: 'OTP 末梢登録が成功的に完了されました。',
    msg_click_key_copy: 'クリックするとキーがコピーされます。',
    otp_login: 'OTP ログイン',
  },
  security: {
    security_auth: 'セキュリティ認証',
    grade: 'レベル',
    condition: '条件',
    restriction: '制限事項',
    no_grade: 'レベルなし',
    no: '無し',
    security_title: 'セキュリティレベル別 条件別制限事項',
  },
  notice_modal: {
    title: 'お知らせ',
    content:
      'お客様の資産を大切に思う RMT です。円滑な取引き安定の為、会員登録を先に行い、取引き開始日は今後告知を通じてお客様へお知らせするように致します。ありがとうございます',
    check: '今日はこれ以上みない',
  },
  admin: {
    search: '検索',
    search_word: '検索ワード',
    sort: '整列',
    desc: '降順(DESC)',
    asc: '昇順(ASC)',
    reset: '初期化',
    submit: '提出',
    regdate: '登録日',
    last_login: '最近のログイン',
    search_target: '検索対象',
    user_id: 'ID',
    email_address: 'Eメールアドレス',
    user_name: '名前',
    member_seq: '会員固有番号',
    regdate_more: '会員登録日(以上)',
    regdate_less: '会員登録日(以下)',
    last_login_more: '最近のログイン(以上)',
    last_login_less: '最近のログイン(以下)',
    no_data: 'なし',
    inviter_user_id: '推薦者ID',
    show_inviter_list: '推薦者リスト',
    num: '番号',
    password: 'パスワード',
    security_level: 'セキュリティレベル',
    loading: 'データを読み込んでいます...',
    ipaddress: 'IPアドレス',
    user_agent: '端末情報',
    login_log_regdate_more: '会員登録日(以上)',
    login_log_regdate_less: '会員登録日(以下)',
    result: '結果',
    total: '全体',
    no_search_login: '検索されたログイン履歴がありません。',
    status: '状態',
    all_show: '全体表示',
    market_title: 'マーケット名',
    deal_source_amount: '公示原財産数量',
    deal_confirmed_source_amount: '確定原財産数量',
    deal_source_max_amount: '最大買収数量',
    deal_max_price: '最大呼値',
    source_asset_title: '原財産',
    deal_holding_source_amount: '待機原財産数量',
    deal_potential_source_amount: '可用原財産数量',
    deal_source_min_amount: '最低買収数量',
    deal_min_price: '最低呼値',
    target_asset_title: '対象資産',
    source_account: '原財産口座',
    app_account: '買収口座',
    fee: '手数料',
    source_amount: '原財産数量',
    deal_account: '売却口座',
    app_price: '持分金額',
    close_date: '終了日',
    no_limit: '(無制限)',
    no_close: '(未終了)',
    no_search_deal: '検索された C2C 売却公示内訳がありません。',
    no_search_app: '検索された C2C 売却要請内訳がありません。',
    transfer_type: '両替タイプ',
    transfer_asset_pair: '資産ペア',
    basic_rate: '適用売買基準レート',
    transfer_source_asset_title: '基準資産',
    transfer_source_account: '基準資産口座',
    exchange_rate: '適用為替',
    transfer_source_amount: '基準資産数量',
    transfer_target_asset_title: '相手資産',
    transfer_target_account: '相手資産口座',
    spread_rate: '適用スプレッド率',
    transfer_target_amount: '相手資産数量',
    no_search_transfer: '検索された両替内訳がありません。',
    confirm_delete: '本当に削除されますか？',
    modal_confirm: '確認',
    c2c_market: 'C2C 市場管理',
    market_source_min_amount: '原財産最低数量',
    market_source_max_amount: '原財産最大数量',
    market_fee_rate: '手数料率',
    market_source_amount_unit: '原財産単位制限',
    is_active: '活性有無',
    market_no_limit: '(制限なし)',
    more_zero: '0 以上',
    no_use_cover: '(使用しない)',
    add: '追加',
    modify: '修正',
    no_c2c_market: '登録された C2C 市場がありません。',
    direct_transfer_market: '両替(クイック買収/売却) 市場管理',
    direct_basic_rate: '売買基準レート',
    direct_bid_spread_rate: '買収スプレッド率',
    direct_allow_bid: '買収取引き許可',
    direct_ask_spread_rate: '売却スプレッド率',
    direct_allow_ask: '売却取引き許可',
    no_direct_market: '登録された両替市場がありません。',
    b2c_market: 'B2C 市場管理',
    asset_manage: '資産管理',
    asset_title: '資産名',
    asset_code: 'コード',
    modal_asset_code: '資産コード',
    asset_decimal: '小数点桁数',
    allow_deposit: '入金許可',
    allow_withdraw: '出金許可',
    delete: '削除',
    no_asset: '登録された資産がありません。',
    asset_plugin: '資産プラグイン',
    plugin_title: 'プラグインタイトル',
    plugin: 'プラグイン',
    plugin_select: 'プラグイン選択',
    start_block: '開始ブロック',
    allow_scan: 'スキャン許可',
    no_asset_plugin: '登録された資産プラグインがありません。',
    c2c_market_modify: 'C2C マーケット修正',
    c2c_market_enroll: 'C2C マーケット登録',
    direct_market_modify: '両替市場修正',
    direct_market_enroll: '両替市場登録',
    asset_modify: '資産修正',
    asset_enroll: '資産登録',
    asset_plugin_modify: '資産プラグイン修正',
    asset_plugin_enroll: '資産プラグイン登録',
    default_info: '基本情報',
    auto: '(自動入力)',
    before_enroll: '(登録前)',
    c2c_market_seq: 'C2C マーケット固有番号',
    c2c_market_regdate: '最初登録日',
    c2c_market_title: 'C2C マーケット名',
    c2c_source_amount_unit: '原財産単位',
    save: '保存',
    enroll: '登録',
    deal_form: '売却者追加作成フォーム',
    msg_save: '保存しますか？',
    msg_enroll: '登録しますか？',
    msg_c2c_modify: 'C2C マーケットが修正されました。',
    msg_c2c_enroll: 'C2C マーケットが新規登録されました。',
    modal_is_active: '活性化',
    allow: '制限する',
    not_allow: '制限しない',
    form_info_add: 'フォーム追加',
    form_info_title: 'フォームタイトル',
    form_info_list_order: '出力順番',
    form_info_description: 'フォームについて簡略な説明を入力してください。',
    field_info_name: '入力スペース名',
    field_info_title: '入力スペースタイトル',
    field_info_description: '入力スペース説明',
    field_info_is_editable: '修正可能',
    field_info_type: '入力スペースタイプ',
    field_info_select: '選択肢集 / 拡張子',
    field_info_no_space: '空スペース代替文字列',
    field_info_is_required: '必須',
    field_info_extension_place: '対応拡張子をカンマ(,)で区分し入力',
    no_target: '(対象ではない)',
    no_field: '登録された入力スペースがありません。',
    lang_search_select: '言語検索及び選択',
    content: '内容',
    locale: 'ロケール',
    new_enroll: '新規登録',
    enroll_lang: '登録された言語',
    value: '値',
    no_lang: '登録された言語項目がありません。',
    lang_item_name: '英文+数字(頭文字 英文)',
    msg_optionset_delete: '本当に選択肢集を削除されますか？',
    no_optionset: '選択肢集未指定',
    yes_optionset: '(選択肢集指定)',
    optionset_add: '追加するには <i class="el-icon-plus"></i> ボタンをクリック',
    optionset_manage: '選択肢集管理',
    title: 'タイトル',
    title_admin_place: '管理者用タイトルを入力してください。',
    description: '説明',
    description_admin_place: '管理者用説明を入力してください。',
    optionset: '選択肢',
    optionset_name: '値名',
    msg_direct_market_modify: '両替市場が修正されました。',
    msg_direct_market_enroll: '両替市場が新規登録されました。',
    direct_market_seq: '両替市場固有番号',
    msg_asset_modify: '資産が修正されました。',
    msg_asset_enroll: '資産が新規登録されました。',
    deposit_form: '入金者追加作成フォーム',
    withdraw_form: '出金者追加作成フォーム',
    msg_plugin_modify: '資産プラグインが修正されました。',
    msg_plugin_enroll: '資産プラグインが新規登録されました。',
    asset_plugin_seq: '資産プラグイン固有番号',
    asset_plugin_name: '資産プラグイン名',
    asset_plugin_start_block: '開始ブロック番号',
    msg_denied: '拒否されますか？',
    msg_denied_success: '拒否処理されました。',
    msg_approve: '承認されますか？',
    msg_approve_success: '承認処理されました。',
    approve: '承認',
    denied: '拒否',
    no_search_cdd: '検索された CDD 証明要請内訳がありません。',
    kyc_type: '証明タイプ',
    kyc_cdd: 'CDD 証明要請内訳',
    type: 'タイプ',
    kyc_is_valid: '有効有無',
    valid: '有効',
    invalid: '無効',
    kyc_expdate: '満了日',
    no_appoint: '(未指定)',
    kyc_cdd_detail: 'CDD 証明要請詳細',
    kyc_cdd_name_id: '名前(ID)',
    real_name: '実名認証名前',
    di: '重複登録確認値',
    ci: '連携情報確認値',
    nationality: '国籍',
    search_is_valid: '有効のみ検索',
    yes: 'はい',
    real_name_list: '実名認証内訳',
    authority: '認証機関',
    cell_carrier: '通信会社',
    sex: '性別',
    ip_address: 'IPアドレス',
    cell_number: '電話番号',
    no_search_real_name: '検索された実名認証内訳がありません。',
    kyc_withdraw_list: '資産出金アドレス証明内訳',
    bank: '銀行',
    holder_name: '所有者名',
    withdraw_address: '出金アドレス',
    no_search_kyc_withdraw: '検索された資産出金アドレス証明内訳がありません。',
    restriction_manage: '制限政策管理',
    restriction_list_order: '検査優先順位',
    restriction_level: 'レベル区間',
    restriction_title: '制限政策名',
    no_restriction: '登録された制限政策がありません。',
    level_manage: 'レベル管理',
    level_list_order: '順序',
    level: 'レベル',
    level_title: 'レベル名',
    no_level: '登録されたレベルがありません。',
    restriction_modify: '制限政策修正',
    restriction_enroll: '制限政策登録',
    level_modify: 'レベル修正',
    level_enroll: 'レベル登録',
    msg_restriction_modify: '制限政策が修正されました。',
    msg_restriction_enroll: '制限政策が新規登録されました。',
    msg_delete: '削除されました。',
    msg_save_success: '保存されました。',
    msg_enroll_success: '登録されました。',
    restriction_target: '制限対象',
    restriction_apply: '下の制限政策を適用する',
    restriction_select: '== 選択 ==',
    no_restriction_target: '登録された制限対象が存在しません。',
    msg_level_modify: 'レベルが修正されました。',
    msg_level_enroll: 'レベルが新規登録されました。',
    msg_level_condition: '下の条件を全て満たさなければならない',
    no_level_condition: '登録された条件が存在しません。',
    restriction_target_list: {
      NONE: '{0}',
      CREATE_ACCOUNT: '{0} {1}',
      LIMIT_ASSET_WITHDRAW_ONE_TIME_AMOUNT: '{0}を {1}に {2}',
      LIMIT_ASSET_WITHDRAW_DAILY_AMOUNT: '{0}を {1}に {2}',
    },
    level_condition_list: {
      NONE: '{0}',
      KYC_CERTIFICATION: '{0}の {1}を完了しなければならない',
      KYC_REALNAME: '{0}をしなければいけない',
      KYC_ASSET_WITHDRAW_ADDRESS_CERTIFICATION:
        '{0}を {1}で 完了しなければならない',
      MAIL_VERIFICATION: '{0}をしなければいけない',
      OTP_REGISTER: '{0}をしなければいけない',
    },
    kyc_certification_type_info: {
      N: '{0}',
      Y: '{0}し {1}秒間 有効にする',
    },
    account_info: '口座情報',
    account_enroll: '口座登録',
    deposit_address: '入金専用アドレス',
    excel_download: '現在結果エクセルダウンロード',
    new_account: '+ 口座新規',
    private_key_copy: '個人キーコピー',
    no_search_account: '検索された口座がありません。',
    msg_account: '開設致しますか？',
    msg_account_modify: '口座が修正されました。',
    msg_account_open: '口座が新規開設されました。',
    request_amount: '申請金額',
    no_search_deposit: '検索された入金内訳がありません。',
    no_search_withdraw: '検索された出金内訳がありません。',
    deposit_detail: '入金申請詳細',
    withdraw_detail: '出金申請詳細',
    withdraw_certification: '認証出金情報',
    service_msg: 'サービス利用に関する必須的設定が可能です。',
    token_secret: 'トークン署名キー',
    token_lifetime: 'トークン有効期間',
    default_locale: '基本ロケール',
    support_locale: '対応ロケール',
    page_display: 'ページ露出',
    use_signup: '会員登録使用',
    is_required: '必須同意',
    valid_time: '有効時間',
    sec: '秒',
    no_kyc_type: '登録された KYC 証明タイプがありません。',
    real_name_setting: '実名認証設定',
    msg_real_name_setting: '本人確認及び実名認証関連設定をします。',
    real_name_authority: '実名認証機関',
    no_real_name_authority: '実名認証を使用しない',
    site_code: 'サイトコード',
    site_pw: 'サイト PW',
    exec_path: '実行経路',
    kyc_type_modify: 'KYC 証明タイプ修正',
    kyc_type_enroll: 'KYC 証明タイプ登録',
    msg_kyc_type_modify: 'KYC 証明タイプが修正されました。',
    msg_kyc_type_enroll: 'KYC 証明タイプが新規登録されました。',
    kyc_type_title: 'KYC 証明タイプ名',
    kyc_type_name: 'KYC 証明タイプ名',
    cdd_valid_time: 'CDD 有効期間',
    use: '使用',
    no_use: '使用しない',
    kyc_form: '作成フォーム',
    mail_setting: 'メール設定',
    msg_mail_setting: 'メール送信時使用される情報を設定します。',
    default_sender: '基本送信者',
    mail_service: 'メールサービス',
    msg_mail_service: 'メール送信有無及びサービス提供者別設定をします。',
    provider: 'サービス提供者',
    no_send_mail: 'メール送信しない',
    provider_domain: 'ドメイン',
    provider_api_key: 'API キー',
    msg_fake:
      '提供者を指定したのと同じ様に動作し、メール送信履歴に記録は残るが実際に送信はされません。',
    alert_setting: 'アラーム設定',
    customer_alert: 'お客様 (HTML 使用可能)',
    admin_alert: '管理者 (HTML 使用可能)',
    replacer: '置換者',
    manager: '対象管理者',
    otp_setting: 'OTP 設定',
    msg_otp_setting: 'OTP 使用に関する設定をします。',
    allow_disable_otp: 'OTP 末梢許可',
    max_otp_count: 'OTP 最大登録件数',
    otp_available_actions: '適用アクション',
    first_page: '開始ページ',
    last_page: '最終ページ',
    cmd_admin_page: '管理者',
    cmd_brokerage_page: '仲介店',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近７日',
    shortcuts_month: '最近 30日',
    msg_balance_adjustment_ask:
      '本当に口座残高強制調整を実行されますか？',
    msg_balance_adjustment_succeed:
      '残高強制調整が成功的に処理されました。',
    price_change: '残高変動履歴',
    balance_adjustment: '残高強制調整',
    msg_balance_forced_adjustment_info:
      'システムエラー、テキスト及び詐欺による残高回収等 残高を強制的に調整が必要な場合にご使用頂けます。',
    msg_balance_forced_adjustment_responsibility:
      '残高強制調整昨日を悪用したり、権限のない者が任意に使用する場合民刑事的責任が課せられる場合があります。',
    msg_balance_forced_adjustment_error:
      '残高強制調整後、予期せぬエラーが発生sる場合があります。',
    msg_balance_forced_adjustment_carefully:
      '実行後、理由情報を変更出来ないため、慎重に入力してください。',
    adjustment_amount: '調整金額',
    increase: '増加',
    deduction: '差引',
    reason: '理由',
    execution: '実行',
    use_statistics_exclude: '統計除外　会員除外',
    connect: '連結対象',
    all: '全体',
    connection_number: '連結対象固有番号',
    change_history: '残高変動履歴',
    performer: '実行者',
    perfor_ip: '実行 IP',
    case_name: 'ケース名',
    occurrence_date: '発生日',
    before_change: '変動前残高',
    after_change: '変動後残高',
    explanation: '説明',
    car: '車',
    system: 'システム',
    not_recorded: '未記録',
    msg_searched_change: '検索された残高変動履歴がありません。',
    account_update_balance_bulk: '口座残高大量職権訂正',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    msg_accountopen: '口座を正常処理されますか？',
    msg_accountopen_success: '口座正常処理に成功しました。',
    msg_accountfraud: '口座を詐欺処理されますか？',
    msg_accountfraud_success: '口座詐欺処理に成功しました。',
    member_is_alive: '脱退会員除外',
    normal: '正常',
    fraud: '詐欺',
    account_detail: '口座詳細',
    as_list: 'リストへ',
    from_use_statistics_exclude: '統計除外出金口座会員除外',
    to_use_statistics_exclude: '統計除外入金口座会員除外',
    from_member_is_alive: '脱退した出金口座会員除外',
    to_member_is_alive: '脱退した入金口座会員除外',
    msg_search_transfer_list: '検索された振替履歴がありません。',
    transfer_list: '振替履歴',
    role: '役割',
    select: '選択',
    msg_grant_roles: '登録された権限別役割がありません。',
    endpoint: '終端点',
    endpoint_select: '終端点選択',
    use_script: 'スクリプト使用',
    target: '対象',
    target_number: '対象固有番号',
    activity_log: '活動記録',
    system_boxmark: '(システム)',
    value_show: '変更値閲覧',
    not_recorded_boxmark: '(未記録)',
    msg_search_activity_list: '検索された活動記録がありません。',
    variable: '変数名',
    before_value: '変更前値',
    after_value: '変更後値',
    settlement_amount: '精算金額',
    account_number: '口座番号',
    msg_adjust_warning: '精算処理は不可逆的です。実行されますか？',
    msg_adjust_success: '手当残高精算処理されました。',
    balance_by_asset: '資産別手当残高',
    adjust_success: '精算処理',
    allowance_adjust_success: '手当精算処理',
    msg_account_select: '口座を選択してください。',
    msg_account_select_no: '精算可能口座が存在していません。',
    account_list: '口座リスト',
  },
  admin_main: {
    sign_out: 'ログアウト',
    control_panel: '設定',
    board: '掲示板',
    member: '会員',
    login_list: 'ログイン履歴',
    trade: '取引所',
    b2c_list: 'B2C 注文内訳',
    c2c_deal_list: 'C2C 売却公示内訳',
    c2c_app_list: 'C2C 買収要請内訳',
    transfer_list: '両替内訳',
    market: '市場',
    security: 'セキュリティ',
    kyc_cdd: 'KYC 証明要請(CDD)',
    kyc_real_name: 'KYC 実名認証',
    kyc_withdraw: 'KYC 出金アドレス(口座)認証',
    security_restriction: 'セキュリティレベル及び制限政策',
    finance: '金融',
    account: '口座',
    deposit_list: '入金内訳',
    withdraw_list: '出金内訳',
    site: 'サイト',
    lang: '言語',
    setting: '設定',
    service: 'サービス',
    mail: 'メール',
    alert: 'イシューお知らせ',
    admin: '管理者',
    membership_group: '会員グループ',
    OAuth2_client: 'OAuth2 クライアント',
    activity_log: '活動記録',
    cs_inquiry_history: 'CS 問い合わせ履歴',
    contract: '契約',
    pr_affiliate: '広報, 提携及び仲介',
    allowance_policy: '手当政策',
    benefit_details: '手当発生及び 施益/受益履歴',
    allowance_balance: '会員資産別手当残高',
    allowance_settlement: '手当精算履歴',
    broker: '仲介店',
    brokerage_balance: '仲介店残高',
    brokers_equity: '仲介店持分履歴',
    brokerage_settlement: '仲介店精算履歴',
    payment_payment: '支払/決済',
    store: '商店',
    fee: '手数料',
    transaction_history: '取引履歴',
    asset_management: '資産管理',
    plug_in: '資産プラグイン管理',
    order_history: 'B2C 注文履歴',
    engagement_details: 'B2C 採決履歴',
    movement_history: 'B2C 資産移動履歴',
    financial_management: '金融及び資金管理',
    transfer_details: '振替履歴',
    withdrawal_transmission_history: '出金転送履歴',
    withdrawal_policy: '出金_政策',
    manageability_access_control: '管理機能接近制御(ACS)',
    settlement_statistics: '精算及び統計',
    phone: '電話',
  },
  admin_member_list: {
    member_list: '会員リスト',
    regdate: '登録日',
    detail: '詳細を見る',
    no_grade: 'レベルなし',
    default: '基本',
    password_msg: '親サイトで修正可能',
    nick_name: 'ニックネーム',
    birthday: '誕生日',
    list: 'リストへ',
    catalog: '会員情報',
    login_log: 'ログイン記録',
    account: '保有口座',
  },
  relation_list: {
    main_intermediary: '** 本仲介店 **',
  },
  outsite_transaction_list: {
    sub_broker: '下位仲介店',
    do_not_select: '選択しない',
    transaction_history: '仲介店帰属外部サイト取引履歴',
    asset_code: '資産コード',
    asset_name: '資産名',
    transaction: '取引 ID',
    transaction_amount: '取引金額',
    amount_of_commission: '手数料金額',
    profit_and_loss: '損益金',
    registration_date: '登録日',
    msg_does_not_exist: '仲介店帰属外部サイト取引が存在しません。',
  },
  brokerage_member_list: {
    sub_broker: '下位仲介店',
    not_selecta: '選択しない',
    msg_not_exist: '仲介店帰属会員が存在していません。',
  },
  index: {
    broker_information: '仲介店情報',
    control_point: '管理点',
    title: 'タイトル',
    id: '所有者ID',
    unique_number: '仲介店固有番号',
    tax_payer_number: '納税者番号',
    number: 'SSN, ITIN, マイナンバー番号及び事業者登録番号等',
    broker_type: '仲介店タイプ',
    phone_number: '電話番号',
    registration_date: '登録日',
    address: '住所',
    identification_code: '仲介店識別コード',
  },
  withdraw_policy: {
    policy_management: '政策管理',
    inspection_priority: '検査優先順位',
    act_of_execution: '実行行為',
    title: 'タイトル',
    msg_no_registration_policy: '登録政策がありません。',
    summary: '概要',
    msg_establish_and_discard:
      '出金承認業務を条件により自動化する政策を樹立し破棄することができます。',
    modification: '政策修正',
    registration: '政策登録',
  },
  pg_feeset: {
    msg_fee_bundle: '手数料括りを基本指定しました。',
    fee_bundle_management: '手数料括り管理',
    title: 'タイトル',
    fee_rate: '全資産手数料率',
    basics: '基本',
    msg_no_fee: '登録された手数料括りがありません。',
    modification: '手数料括り修正',
    registration: '手数料括り登録',
  },
  member_view: {
    notification: 'お知らせ',
    denial_of_service: 'サービス拒否',
    existing_password: '空欄の場合、会員情報修正時既存パスワード承継',
    chief_administrator: '最高管理者',
    authorization: '権限付与',
    exclude_statistics: '統計除外',
    prevention_of_contamination: '精算、統計等の結果から除外し汚染防止',
    security_rating_value: '保安レベル値',
    fixation: '固定',
    unrated: 'レベル無し',
    ratinga: '登録',
    assigned_groups: '割当られたグループ',
    group_name: 'グループ名',
    group_title: 'グループタイトル',
    msg_no_group: '登録されたグループがありません。',
    otp_list: 'OTP リスト',
    registration_date: '登録日',
    msg_no_otp: '登録された OTPがありません',
    group_registration: '会員グループ登録',
    registration: '登録',
    membership_group_registration: '会員グループ登録',
  },
  member_list: {
    seq: '会員固有番号',
    user_id: 'ID',
    password: 'パスワード',
    email_address: 'Eメール',
    user_name: '名前',
    is_denied: '停止有無',
    is_admin: '最高管理者有無',
    regdate: '加入日',
    last_login: '最近ログイン',
    is_alive: '脱退有無',
    deleted_date: '脱退日',
    security_level: '保安レベル',
    use_statistics_exclude: '統計除外',
    is_security_level_locked: '保安レベル値固定有無',
    inviter_seq: '推薦者会員固有番号',
    inviter_user_id: '推薦者会員ID',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    member: '会員',
    statistics_exclude_members: '統計除外会員除外',
    chief_administrator: '最高管理者',
    denial_of_service: 'サービス拒否',
  },
  member_invite_relation_list: {
    yourself: '** 本人 **',
    area: 'エリア(px)',
    designation: '指定',
  },
  member_group_list: {
    membership_group: '会員グループ',
    msg_no_membership_group: '登録された会員グループがありません。',
    group_modification: '会員グループ修正',
    group_registration: '会員グループ登録',
  },
  market: {
    fee_rate: '売却公示者手数料率',
    requester_fee_rate: '買収要請者手数料率',
    market_name: '市場名',
    market_code: '市場コード',
    base_assets: '基準資産',
    quantity_constructor_commission: '数量造成者手数料率',
    relative_assets: '相手資産',
    quantity_user_fee_rate: '数量利用者手数料率',
    msg_no_registered: '登録された B2C 市場がありません。',
    modification: '公開市場修正',
    registration: '公開市場登録',
  },
  finance_catalog: {
    financial_product_management: '金融商品管理',
    name: '名前',
    title: 'タイトル',
    number_of_subscriptions: '加入回数',
    total_subscription_amount: '加入金額合計',
    msg_no_registration: '登録された金融商品がありません。',
    modification: '金融商品修正',
    registration: '金融商品登録',
  },
  cs_ticket_list: {
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_close: '問い合わせを終了しますか？',
    msg_answer_complete: '問い合わせを返答完了処理されますか？',
    above: '登録日(以上)',
    less_than: '登録日(以下)',
    statistics_exclude_members: '統計除外会員除外',
    inquiry_history: 'CS 問い合わせ履歴',
    statea: '状態',
    registration_date: '登録日',
    cs_inquiry_id: 'CS問い合わせID',
    title: 'タイトル',
    non_member: '(非会員)',
    answer_complete: '返答完了',
    close: '終了',
    contact_request_details: 'CS 問い合わせ要請詳細',
  },
  cs_faq_list: {
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    above: '登録日(以上)',
    less_than: '登録日(以下)',
    registration: '登録',
    cs_faq_history: 'CS FAQ 履歴',
    csfaq_number: 'CSFAQ固有番号',
    csfaq_title: 'CSFAQタイプタイトル',
    title: 'タイトル',
    registration_date: '登録日',
    modify: '修正',
    csfaq_registration: 'CS FAQ 登録',
    csfaq_modify: 'CS FAQ 修正',
  },
  contract_catalog: {
    managing_contract_documents: '契約文書管理',
    name: '名前',
    title: 'タイトル',
    document_type: '文書タイプ',
    mainly_locale: 'メインロケール',
    registration_date: '登録日',
    msg_no_document: '登録された契約文書がありません。',
    managing_contract_forms: '契約フォーム管理',
    msg_no_forms: '登録された契約フォームがありません。',
    modifying_document: '契約文書修正',
    register_document: '契約文書登録',
    modifying_forms: '契約フォーム修正',
    register_forms: '契約フォーム登録',
  },
  config_service: {
    msg_save: '保存されますか？',
    check: 'はい',
    second: '秒',
  },
  config_phone: {
    phone_settings: '電話設定',
    msg_seting: '発信時使用される情報を設定します。',
    caller_line_number: '発信者回線番号',
    telephone_service: '電話サービス',
    msg_set_the_settings: '発信有無及びサービス提供者に対する設定をします。',
    do_not_send: '発信しない',
    msg_not_actually_emit:
      '提供者を指定したのと同じ様に動作し、発信履歴に記録はされるが実際に発信はされません。',
  },
  config_member: {
    msg_save: '保存されますか？',
    check: '確認',
    msg_no_exist: '存在しないグループです',
    login_identifier: 'ログイン識別者',
    all_available_identifiers: '使用可能な全ての識別者',
    enable_allow: '推薦者グループ許容使用',
    acceptance_group: '推薦者許容グループ',
  },
  config_cs: {
    type_of_cs_statement: 'CS 問い合わせタイプ',
    msg_no_cs_statement: '登録された CS 問い合わせタイプがありません。',
    cs_faq_type: 'CS FAQ タイプ',
    type_name: 'タイプ名',
    type_namea: 'タイプ名',
    msg_no_cs_faq: '登録された CS FAQ タイプがありません。',
    modify: 'CS 問い合わせタイプ修正',
    registration: 'CS 問い合わせタイプ登録',
    faq_modify: 'CS FAQ タイプ修正',
    faq_registration: 'CS FAQ タイプ登録',
  },
  brokerage_catalog_relation_list: {
    main_intermediary: '** 本仲介店 **',
  },
  asset_plugin_list: {
    title: 'プラグインタイトル',
    scan_status: 'スキャン有無',
    plug_ins: '資産プラグインリスト',
  },
  asset_list: {
    asset_code: '資産コード',
    active: '活性有無',
    deposit: '入金許容',
    withdrawala: '出金許容',
    output_order: '出力順序',
    asset_list: '資産リスト',
  },
  affiliate_policy: {
    management: '手当政策管理',
    output_ordera: '出力順序',
    act: '対象行為',
    whether_or_not: '全域有無',
    title: 'タイトル',
    msg_no_allowance: '登録された手当政策がありません。',
    rectification: '手当政策修正',
    registration: '手当政策登録',
  },
  acs_catalog: {
    manage_roles: '役割管理',
    name: '名前',
    title: 'タイトル',
    end_point_method: '終端点メソッド',
    end_point_path: '終端点経路',
    msg_no_role: '登録された役割がありません。',
    manage_permissions: '権限管理',
    modify_role: '役割修正',
    registering_role: '役割登録',
    modify_permissions: '権限修正',
    registration_authority: '権限登録',
  },
  account_update_balance_bulk: {
    msg_account_number: '口座番号が欠番なため保留されました。',
    msg_not_exist: '存在しない入金専用住所なため保留されました。',
    msg_not_match_depositor: '口座名義人名が一致しないため保留されました。',
    choice: '1. 設定及びファイル選択',
    excel: 'エクセルファイル選択',
    prosecutor: '2. 有効性検査',
    run_account_validation: '口座有効性検査実行',
    msg_before_execution:
      '実行前です。正確な残高大量職権訂正の為に必ず実行しないといけません。',
    msg_execution_completed:
      '実行完了しました。これから残高大量職権訂正をすることができます。',
    msg_running:
      '実行中です。所要時間はデータの量に比例します。少々お待ちください。',
    balance_correction: '3. 残高訂正',
    current_status: '現在状態',
    msg_run_button:
      "実行前です。'実行' ボタンをクリックすると残高大量職権訂正を始めます。",
    msg_download_excel:
      "実行完了しました。万が一を備え'現在結果エクセルダウンロード' ボタンをクリックし結果を保存してください。",
    msg_wait_a_moment:
      '実行中です。所要時間はデータの量に比例します。ページの移動せず少々お待ちください。',
    adjusted_amount: '調整金額',
    increase: '増加',
    deductinga: '削減',
    reason: '理由',
    must_matcm: '口座名義人名が必ず一致しないといけない',
    practice: '実行',
    number: '番号',
    name: '名前',
    bank_account_number: '口座番号',
    deposit_only_addresses: '入金専用住所取扱い',
    amount: '金額',
    account_number_existence: '口座番号存在有無',
    depositor_name_consistency: '口座名義人名一致有無',
    unique_number: '照会された口座固有番号',
    account_assets: '口座資産',
    checked_depositor: '照会された口座名義人名',
    member_unique_number: '照会された会員固有番号',
    state: '状態',
    result_message: '結果メッセージ',
    msg_not_exist_excel:
      'エクセルファイルが選択されなかったかデータが存在していません。',
  },
  login_me: {
    select_an_intermediary: '仲介店選択',
    shortcuts: 'ショートカット',
    back: '戻る',
  },
  brokerage_console_main: {
    pr_affiliate: '広報, 提携及び仲介',
    brokerage_catalog: '仲介店情報',
    sub_broker: '下位仲介店',
    relation_list: '関係図',
    affiliated_member: '帰属会員',
    external_site_transaction: '外部サイト取引履歴',
    brokerage_balance: '仲介店残高',
    brokers_equity: '仲介店持分履歴',
    brokerage_settlement: '仲介店精算履歴',
  },
  share_list: {
    seq: '仲介店持分固有番号',
    amount: '手当金額',
    asset_code: '資産コード',
    asset_seq: '資産固有番号',
    asset_title: '資産名',
    base_amount: '元金額',
    base_amount_target: '元金額対象',
    benefactor_email_address: '施益者 Eメールアドレス',
    benefactor_member_seq: '施益者会員固有番号',
    benefactor_type: '施益者タイプ',
    benefactor_user_id: '施益者 使用者ID',
    benefactor_user_name: '施益者 使用者名',
    beneficiary_email_address: '受益者 Eメールアドレス',
    beneficiary_member_seq: '受益者会員固有番号',
    beneficiary_type: '受益者タイプ',
    beneficiary_user_id: '受益者使用者ID',
    beneficiary_user_name: '受益者 使用者名',
    causer_email_address: '発生者 Eメールアドレス',
    causer_seq: '発生者会員固有番号',
    causer_user_id: '発生者使用者ID',
    causer_user_name: '発生者使用者名',
    log_beneficiary_seq: '手当発生受益者固有番号',
    log_policy_seq: '手当発生適用政策固有番号',
    log_seq: '手当発生固有番号',
    policy_amount: '手当政策指定手当金額',
    policy_seq: '適用手当政策固有番号',
    policy_title: '適用手当政策名',
    target_action: '対象行動タイプ',
    target_seq: '対象固有番号',
    affiliate_log_benefactor_seq: '手当発生施益者固有番号',
    brokerage_seq: '仲介店固有番号',
    brokerage_title: '仲介店タイトル',
    inherited_amount: '被相続額',
    acquire_rate: '取得率',
    acquire_rate_from_amount: '手当金額対比取得率',
    acquire_amount: '取得額',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    equity_history: '仲介店持分履歴',
    search: '検索',
    sub_broker: '下位仲介店',
    not_select: '選択しない',
    causer: '発生者',
    behavior_type: '行動タイプ',
    occurrence_date: '発生日',
    applied_policy_name: '適用政策名',
    beneficiary: '施益者',
    allowance_assets: '手当資産',
    allowance_amount: '手当金額',
    number: '番号',
    brokerage_name: '仲介店名',
    acquisition_rate: '手当金額対比取得率',
    acquisition_amount: '取得額',
    msg_brokerage_catalog_share_list_no: '検索された仲介店持分履歴がありません。',
  },
  child_list: {
    modify_sub_brokerage: '下位仲介店修正',
    sub_broker_registration: '下位仲介店登録',
    List_sub_brokers: '下位仲介店リスト',
    new_sub: '+ 下位仲介店新規登録',
    title: 'タイトル',
    broker_type: '仲介店タイプ',
    broker_details: '仲介店詳細',
    subpoint_registration: '下位店登録',
    msg_no_sub: '検索された下位仲介店がありません。',
  },
  child_info: {
    msg_wantto_edit: '修正されますか？',
    msg_brokerage_register: '仲介店を登録しますか？',
    msg_brokerage_modify_success: '仲介店が成功的に修正されました。',
    msg_brokerage_register_success: '仲介店が成功的に登録されました。',
    brokerage_allowed_not: '下位仲介店登録不可',
    lowest_broker_type: '最下位仲介店タイプ',
    msg_cannot_designate: 'を持った仲介店を管理店に指定できません。',
    control_point: '管理店',
    title: 'タイトル',
    management_poin: '管理店取得率',
    owner_ID: '所有者ID',
    broker_number: '仲介店固有番号',
    payer_number: '納税者番号',
    number: 'SN, ITIN, マイナンバー番号及び事業者登録番号等',
    broker_type: '仲介店タイプ',
    phone_number: '電話番号',
    rgistration_date: '登録日',
    not_registered: '(未登録)',
    address: '住所',
    identification_code: '仲介店識別コード',
    a: '',
  },
  withdraw_transfer_list: {
    seq: '出金申請固有番号',
    account_seq: '口座固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    account_number: '口座番号',
    from: '送信アドレス',
    to: '受信アドレス',
    txid: 'TXID',
    bank_code: '銀行',
    asset_title: '資産名',
    asset_code: '資産コード',
    amount: '転送金額',
    fee_amount: '転送手数料',
    status: '状態',
    message: 'メッセージ',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    withdrawal_transmission: '出金転送履歴',
    statistics_exclude_members: '統計除外 会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    transmit: '送信',
    receive: '受信',
    msg_no_withdrawaa: '検索された出金転送履歴がありません。',
  },
  withdraw_policy_info: {
    policy_modified: '政策が修正されました。',
    policy_registered: '政策が登録されました。',
    title: 'タイトル',
    type_of_execution: '実行タイプ',
    choice: '選択',
    inspection_priority: '検査優先順位',
    condition: '条件',
    sequence: '順序',
    must: '下の条件を全て満たす必要がある',
    msg_no_registered: '登録された条件がありません。',
  },
  withdraw_list: {
    seq: '出金申請固有番号',
    account_seq: '口座固有番号',
    member_seq: '会員固有番号',
    withdraw_address_certification_seq: '出金住所認証固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメール住所',
    account_number: '口座番号',
    holder_name: '口座名義人名',
    bank_code: '銀行',
    fee_type: '手数料賦課タイプ',
    fee_amount: '手数料賦課額',
    net_amount: '最終金額',
    asset_title: '資産名',
    asset_code: '資産コード',
    request_amount: '申請金額',
    status: '状態',
    regdate: '登録日',
    withdraw_address: '出金認証アドレス',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    withdrawal_application_details: '出金申請履歴',
    msg_approve: '全体承認されますか？',
    msg_reject: '全体拒否されますか？',
    msg_approved: '全体承認されました。',
    msg_rejected: '全体拒否されました。',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    charging_type: '手数料賦課タイプ',
    charge_fee: '手数料賦課額',
    final_amount: '最終金額',
    full_approval: '全体承認',
    total_deny: '全体拒否',
    selected_withdrawal: '選択した出金履歴',
    cancellation: 'キャンセル',
    completion: '完了',
  },
  withdraw_info: {
    msg_re_transfer:
      '(再)転送時、重複で転送される可能性があります。実行されますか？',
    notification: 'お知らせ',
    msg_registered: '転送要請が登録されました。',
    msg_key_in: '転送情報を Key-In します。実行されますか？',
    msg_information: '転送情報が登録されました。',
    application_details: '申請詳細',
    re_transfer: '(再)転送',
    key_in: '転送情報 Key-In',
    amount_transferred: '転送金額',
    transfer_fee: '転送手数料',
    send_address: '送信アドレス',
    incoming_address: '受信アドレス',
    message: 'メッセージ',
    submission: '提出',
    transfer_history: '転送履歴',
  },
  statistic: {
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    category: '項目',
    property: '資産',
    direct: 'ダイレクト両替手数料',
    C2C: 'C2C 手数料',
    deposit_amount: '入金金額',
    withdrawal_amount: '出金金額',
    withdrawal_fee: '出金手数料',
    announces_sale: '売却公示者',
    purchasing_discloser: '買収公示者',
    msg_not_date:
      '日にちが選択されていないか、選択された日にち区間条件と一致するデータがありません。',
  },
  public_trade_list: {
    seq: ' 市場採決固有番号',
    market_seq: '公開市場固有番号',
    market_title: '公開市場名',
    market_code: '公開市場コード',
    is_buyer_maker: '買収者側数量造成者有無',
    amount: '採決数量',
    price: '採決単価',
    maker_member_seq: '数量造成者会員固有番号',
    maker_user_id: '数量造成者ID',
    maker_user_name: '数量造成者名前',
    maker_email_address: '数量造成者Eメールアドレス',
    maker_account_seq: '数量造成者口座固有番号',
    maker_account_number: '数量造成者口座番号',
    maker_order_seq: '数量造成者注文固有番号',
    maker_fee_amount: '数量造成者手数料',
    taker_member_seq: '数量利用者会員固有番号',
    taker_user_id: '数量利用者ID',
    taker_user_name: '数量利用者名前',
    taker_email_address: '数量利用者Eメールアドレス',
    taker_account_seq: '数量利用者口座固有番号',
    taker_account_number: '数量利用者口座番号',
    taker_order_seq: '数量利用者注文固有番号',
    taker_fee_amount: '数量利用者手数料',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    b2c_engagemen: 'B2C 採決履歴',
    except_creator: '統計除外数量造成者会員除外',
    exclude_users: '統計除外数量利用者会員除外',
    b2c_movements: 'B2C 資産移動履歴',
    buying: '買収',
    sell: '売却',
    common: '共通',
    market_buildera: '市場数量造成者情報',
    market_user: '市場数量利用者情報',
    unique_number: '採決固有番号',
    id: 'ID',
    account_number: '口座番号',
    fee: '手数料',
    quantity_constructor_status: '買収者側数量造成者有無',
    name: '名前',
    order_unique_number: '注文固有番号',
    msg_no_b2c: '検索された B2C 注文履歴がありません。',
  },
  public_order_list: {
    seq: '公開市場注文固有番号',
    market_seq: '公開市場固有番号',
    market_title: '公開市場名',
    market_code: '公開市場コード',
    account_seq: '口座固有番号',
    account_number: '口座番号',
    user_id: 'ID',
    user_name: '名前',
    call_price: '呼値',
    call_amount: '呼値数量',
    executable_amount: '採決可能数量',
    filled_amount: '採決数量',
    commulative_target_amount: '累積相手資産数量',
    is_executable: '採決可能有無',
    side_type: '取引方向',
    status: '状態',
    closed_date: '終結日',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    b2c_list: 'B2C 注文履歴',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    b2c_movements: 'B2C 資産移動履歴',
    unique_number: '注文固有番号',
    bank_account_number: '口座番号',
    asking_price: '呼値',
    fastened: '採決可能数量',
    relative: '累積相手資産数量',
    transaction_direction: '取引方向',
    the_asking_price: '呼値数量',
    tightening_quantity: '採決数量',
    can_be_fastened: '採決可能有無',
    state: '状態',
    closing_date: '終結日',
    unterminated: '未終結',
    msg_no_b2c: '検索された B2C 注文履歴がありません。',
  },
  public_market_info: {
    msg_modify: '修正されました。',
    msg_registered: '登録されました。',
    market_seq: '公開市場固有番号',
    market_name: '市場名',
    code: 'コード',
    allow_deposit: '預置許容',
    allow_withdrawals: '引出許容',
    output_order: '出力順序',
    minimum_asking: '最小呼値数量',
    use: '使用',
    base_assets: '基準資産',
    relative_assets: '相手資産',
    creator: '数量造成者手数料率',
    user: '数量利用者手数料率',
  },
  public_balance_transfer_list: {
    seq: '公開市場残高移動固有番号',
    market_seq: '公開市場固有番号',
    market_title: '公開市場名',
    market_code: '公開市場コード',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    account_number: '口座番号',
    account_seq: '口座固有番号',
    balance_seq: '公開市場残高固有番号',
    transfer_type: '移動タイプ',
    amount: '移動数量',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    B2C: 'B2C 資産移動履歴',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    movements: 'B2C 資産移動履歴',
    bank_account_number: '口座番号',
    msg_no_b2c: '検索された B2C資産 移動履歴がありません。',
  },
  private_market_info: {
    direct_exchange_market: 'ダイレクト両替市場追従',
    do_not_follow: '追従しない',
    follow: '追従',
    choice: '選択',
    designated: '市場を追従対象に指定する',
    minimum_spread: '最小スプレッド比率',
    maximum_spread: '最大スプレッド比率',
    announces: '売却公示者',
    solicitor: '売却要請者',
    safety_type: '購入安全タイプ',
    msg_immediately:
      '売却公示者と買収要請者の取引が即座に行われるようにします。取引速度が一番早いです。',
    msg_disclosure:
      "売却公示者が会社側に売却する資産をまず預置し売却公示登録時対象資産の支払方法を指定します。買収要請者は売却公示者が指定した対象資産支払方法によって売却公示者へ対象資産を支払します。買収要請者が'支払完了' 処理すると取引状態解消前まで売却公示者の口座に支給停止が設定されます。",
    msg_requester:
      "売却要請者が会社側に買収する資産をまず預置し買収要請登録時元資産の支払方法を指定します。売却公示者は買収要請者が指定した元資産支払方法によって買収要請者へ元資産を支払します。売却公示者が'支払完了' 処理すると取引状態解消前まで買収要請者の口座に支給停止が設定されます。",
    msg_both_sides:
      ' 売却公示者と買収要請者両方とも預置しないようにします。取引者お互い信頼があると判断された時のみ使用するようにします。',
    form: '買収要請者追加作成フォーム',
  },
  private_deal_list: {
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
  },
  private_application_list: {
    seq: '買収要請固有番号',
    market_seq: 'c2c マーケット固有番号',
    market_title: 'c2c マーケット名',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    source_asset_title: '元資産名',
    source_asset_code: '元資産コード',
    target_asset_title: '対象資産名',
    target_asset_code: '対象資産コード',
    deal_seq: 'c2c 売却公示固有番号',
    deal_member_seq: 'c2c 売却公示会員固有番号',
    deal_fee_amount: 'c2c 売却公示者手数料額',
    deal_account_number: 'c2c 売却口座',
    account_number: 'c2c 買収口座',
    account_seq: 'c2c 買収口座固有番号',
    source_amount: '元資産数量',
    fee_amount: 'c2c 買収要請者手数料額',
    price: '数量当たり価格',
    status: '状態',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_change: '本当に状態を変更されますか？',
    msg_complete: '状態変更が完了しました。',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    c2c_purchase: 'C2C 買収要請履歴',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    sales_discloser_fee: '売却公示者手数料額',
    price_per_quantity: '数量当たり価格',
    purchase_requeste: '買収要請者手数料額',
    cancellation: 'キャンセル',
    Payment: '支払',
    companion: '返上',
    confirmation: '確定',
  },
  pg_transaction_list: {
    seq: '取引固有番号',
    asset_seq: '資産固有番号',
    user_id: 'ID',
    user_name: '名前',
    merchant_id: 'マーケットID',
    merchant_name: 'マーケット名',
    order_id: 'マーケット注文番号',
    transaction_id: '取引ID',
    feeset_title: '適用手数料括り',
    fee_rate: '適用手数料率',
    fee_amount: '賦課手数料額',
    amount: '取引金額',
    net_amount: '最終精算金額',
    refundable_amount: '払い戻し可能金額',
    payer_name: '決済者名',
    transaction_type: '取引タイプ',
    status: '状態',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    pg_transaction: 'PG 取引履歴',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    application_fee: '適用手数料括り',
    transaction_name: '取引名称',
    not_applied: '手数料括り未適用',
    no_pg: '検索された PG 取引履歴がありません。',
  },
  pg_merchant_nav: {
    list: 'リストへ',
    information: 'マーケット情報',
  },
  pg_merchant_list: {
    seq: 'マーケット固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    merchant_id: 'マーケットID',
    merchant_name: 'マーケット名',
    api_signature: 'マーケット署名キー',
    status: '状態',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    list_of_stores: 'マーケットリスト',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    store_name: 'マーケット名',
    registration_date: '登録日',
    store_details: 'マーケット詳細',
  },
  pg_merchant_info: {
    store_id: 'マーケットID',
    store_unique_number: 'マーケット固有番号',
    store_name: 'マーケット名',
    application_fee: '適用手数料括り',
    follow_defaul: '基本指定された照す量括りに従う',
    no_default: '[基本指定手数料括り無し]',
    store_signature_key: 'マーケット署名キー',
    automatic_generation: '(自動生成)',
  },
  pg_feeset_info: {
    title: 'タイトル',
    electronic_property_fee: '全資産手数料率',
    fee_by_asset: '資産別手数料',
    settlement_assets: '決済資産',
    commission_rate: '手数料率',
    msg_no_registered: '登録された手数料がありません',
    choice: '選択',
  },
  oauth2_client_list: {
    client_information: 'クライアント情報',
    client_new: 'クライアント新規',
    id: 'クライアント ID',
    oauth2_client: 'Oauth2 クライアント',
    new: '新規生成',
    name: 'クライアント名',
    secret: 'クライアント Secret',
    registration_date: '登録日',
    msg_no_clints: '登録されたクライアントがありません。',
  },
  oauth2_client_info: {
    msg_modified: 'クライアント修正されました。',
    msg_registered: 'クライアント登録されました。',
    name: 'クライアント名',
    id: 'クライアント ID',
    automatic_generation: '(自動生成)',
    secret: 'クライアント Secret',
    url: 'リディレクト URI',
    right: '権限',
    choice: '選択',
    msg_not_egistered: '登録されたクライアント権限がありません。',
  },
  member_nav: {
    retained: '保有 OAuth2 Client',
    recommended_relationship: '推薦関係図',
  },
  member_group_info: {
    msg_modified: '会員グループが修正されました',
    msg_registered: '会員グループが登録されました',
    member_group: '会員グループ名',
    member_group_name: '会員グループ名',
    member_output_order: '会員出力順序',
  },
  member_by_group_info: {
    msg_membership_group: '会員鵜ループが登録されました。',
    select_group: 'グループリスト',
    msg_select_group: 'グループを選択してください',
  },
  member_affiliate_policy: {
    msg_completed_successfully: '手当政策適用が成功的に完了されました。',
    msg_successfully_removed:
      '会員適用手当政策が成功的に抹消されました。',
    membership_allowance_policy: '会員適用手当政策',
    msg_select: '割当てる手当政策を選択してください。',
    msg_not_exist: '割当可能な手当政策が存在していません。',
    application: '適用',
    act_of_subject: '対象行為',
    policy_title: '政策タイトル',
    msg_no_allowance: '適用された手当政策がありません。',
  },
  member_acs_grant: {
    member_applied_acs: '会員適用 ACS 権限',
    msg_select_acs: '割り当てる ACS 権限を選択してください。',
    msg_not_exist: '割当可能な ACS 権限が存在していません。',
    application: '適用',
    privilege_name: '権限名',
    permission_title: '権限タイトル',
    msg_not_have: '適用された ACS 権限がありません。',
  },
  loginlog_list: {
    search: '検索',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    msg_successfully: 'ACS 権限適用が成功的に完了されました。',
    msg_revoked: '会員適用 ACS 権限が成功的に抹消されました。',
  },
  lang_search_item: {
    elimination: '削除',
  },
  kyc_realname_list: {
    kyc_realname_list: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    seq: '実名認証固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    authority: '認証機関',
    name: '実名認証名',
    sex: '性別',
    nationality: '国籍',
    birth_date: '誕生日',
    di: '重複加入確認値',
    ci: '連係情報確認値',
    cell_carrier: '通信会社',
    cell_number: '電話番号',
    status: '状態',
    is_valid: '有効有無',
    closed_date: '終結日',
    expdate: '満了日',
    ipaddress: 'IP アドレス',
    regdate: '登録日',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    real_name: '実名認証履歴',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
  },
  kyc_certification_info: {
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
  },
  kyc_asset_withdraw_address_certification_list: {
    _no: '番号',
    seq: 'KYC 資産出金アドレス認証固有番号',
    asset_seq: '資産固有番号',
    asset_code: '資産コード',
    asset_title: '資産名',
    bank_code: '銀行コード',
    withdraw_address: '出金アドレス',
    holder_name: '所有者名',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    status: '状態',
    is_valid: '有効有無',
    regdate: '登録日',
    expdate: '満了日',
    closed_date: '終結日',
    ipaddress: 'IP アドレス',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    KYC_authentication: 'KYC出金アドレス(口座)認証',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
  },
  finance_return_list: {
    seq: '手当残高固有番号',
    member_unique_number: '会員固有番号',
    id: 'ID',
    name: '名前',
    email: 'Eメールアドレス',
    balance: '残高',
    cumulative_amount: '累積金額',
    first_payment_date: '最初支給日',
    asset_name: '資産名',
    asset_code: '資産コード',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    financial_return_history: '金融返還履歴',
    return_account_number: '返還口座番号',
    fund_account_number: '資金口座番号',
    statistics_exclude_members: '統計除外会員除外',
    withdrawal_members_excluded: '脱退会員除外',
    financial_instruments_name: '金融商品名',
    return_type: '返還タイプ',
    amount: '元金額',
    principal_amount: '元利金額',
    registration_date: '登録日',
    type_of_financial: '金融商品タイプ',
    patient_type: '返還者タイプ',
    amount_of_money: '利子額',
    msg_no_financial: '検索された金融返還がありません。',
  },
  finance_nav: {
    setting: '設定',
    breakdown_of_funds: '資金履歴',
    return_history: '返還履歴',
    dividend_details: '配当履歴',
  },
  finance_instrument_info: {
    title: 'タイトル',
    description_summary: '説明要約',
    type_of_financial: '金融商品タイプ',
    select_product_type: '(商品タイプ選択)',
    application: '適用契約フォーム',
    select: '(契約フォーム選択)',
    name: '名前',
    executable_asset: '実行資産',
    select_asset: '資産選択',
    subscription_start_date: '加入開始日',
    use: '使用',
    msg_select_start_date: '開始日を選択してください',
    disable_subscription_start: '加入開始日使用しない',
    end_date: '加入終了日',
    msg_select_end_date: '終了日を選択してください',
    disable_subscription_end: '加入終了日使用しない',
    date_of_execution: '実行開始日',
    execute_end: '実行終了日',
    settlement_date: '精算日 開始日',
    execution_amount_bundle: '実行金額括り',
    join_and_run: '{0} 単位で加入後実行',
    msg_execution_asset: '実行資産を選択してください',
    minimum_amount: '最小実行金額',
    disable_minimum: '最小実行金額使用　使用しない',
    maximum_amount: '最大実行金額',
    disable_maximum: '最大実行金額使用　使用しない',
    profit_for_dividends: '金融商品配当用利益',
    dividend_profit_assets: '配当用利益資産',
    dividend_income: '配当利益金',
    choice: '選択',
    msg_no_benefit: '登録された金融商品配当利益がありません。',
  },
  finance_fund_list: {
    balance_unique_number: '手当残高固有番号',
    member_unique_number: '会員固有番号',
    id: 'ID',
    name: '名前',
    email_address: 'Eメールアドレス',
    balance: '残高',
    accumulated_amount: '累積金額',
    first_payment_date: '最初支給日',
    asset_title: '資産名',
    asset_code: '資産コード',
    msg_server_overload:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    financial_details: '金融資金履歴',
    fund_account_number: '資金口座番号',
    execution_account_number: '実行口座番号',
    statistics_exclude_members: '統計除外　会員除外',
    members_excluded: '脱退会員除外',
    financial_product: '金融商品名',
    account_number: '資金口座番号',
    date_of_execution: '実行開始日',
    execution_amount: '実行金額',
    cancellation_status: '解約有無',
    settlement_start: '生産開始日',
    financial_instrument: '金融商品タイプ',
    execution: '事項口座番号',
    expiry_date: '満期日',
    completed_or_not: '返還完了有無',
    revocation_type: '解約タイプ',
    registration_date: '登録日',
    msg_no_financial: '検索された金融資金がありません。',
  },
  direct_transfer_list: {
    exchange_unique_number: '両替固有番号',
    member_unique_number: '会員固有番号',
    rotation_type: '両替タイプ',
    sales_base_rate: '適用　売買基準レート',
    id: 'ID',
    name: '名前',
    base_assets: '基準資産',
    base_assets_account: '基準資産口座',
    applied_exchange_rate: '適用為替',
    base_assets_quantity: '基準資産数量',
    relative_assets: '相手資産',
    relative_asset_account: '相対資産口座',
    relative_asset_quantity: '相手資産数量',
    applied_spread_rate: '適用スプレッド率',
    registration_date: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_when_downloading_excel:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    exchange_details: '両替履歴',
    statistics_exclude_members: '統計除外　会員除外',
    withdrawal_members_excluded: '脱退会員除外',
  },
  deposit_list: {
    seq: '入金申請固有番号',
    account_seq: '口座固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    account_number: '口座番号',
    asset_title: '資産名',
    asset_code: '資産コード',
    request_amount: '申請金額',
    status: '状態',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    msg_approve: '全体承認されますか？',
    msg_reject: '全体拒否されますか？',
    msg_approved: '全体承認されました。',
    msg_rejected: '全体拒否されました。',
    use_statistics_exclude: '統計除外会員除外',
    member_is_alive: '脱退会員除外',
    approve: '全体承認',
    reject: '全体拒否',
    deposit_request: '入金申請履歴{0}',
    selecte_deposit_history: '選択した入金履歴',
    application_amount: '申請金額',
    cancel: 'キャンセル',
    done: '完了',
  },
  contract_form_info: {
    name: '名前',
    title: 'タイトル',
    contract_document: '契約文書',
    required_consent: '必須同意有無',
    select: '選択',
    required: '必須',
    is_agree_required: '必須同意',
    msg_contract_document_no: '登録された契約フォーム文書がありません。',
  },
  cs_ticket_type_info: {
    msg_cs_type_modify: 'CS 問い合わせタイプが修正されました',
    msg_cs_type_register: 'CS 問い合わせタイプが登録されました',
    title: 'CS 問い合わせタイプ名',
    name: 'CS 問い合わせタイプ名',
    list_order: 'CS 問い合わせ出力順序',
    use_content: 'CS 問い合わせ内容使用',
    allow_guest: 'CS 問い合わせ非会員許容',
    use_notify: 'CS 問い合わせ顧客事件お知らせ許容',
    use_notify_manager: 'CS 問い合わせ管理者事件お知らせ許容',
  },
  cs_ticket_info: {
    msg_inquiry_answer: '問い合わせに返答されますか？',
    msg_inquiry_answer_success: '問い合わせ返答に成功しました',
    msg_inquiry_ending: '問い合わせを終了しますか？',
    msg_inquiry_answer_ending: '問い合わせを返答完了処理しますか？',
    non_member: '非会員',
    title: 'タイトル',
    content: '内容',
    nodone: '(無し)',
    answer: '返答',
    answer_register: '返答登録',
    answer_success: '返答完了',
    ending: '終結',
  },
  cs_faq: {
    modify: '修正',
    register: '登録',
    msg_cs_modify: 'CS FAQが修正されました。',
    msg_cs_register: 'CS FAQが登録されました。',
    cs_info: 'CS FAQ 情報',
    cs_type: 'CS FAQ タイプ',
    type_selete: 'タイプ選択',
    title: 'タイトル',
    content: '内容',
  },
  cs_faq_type_info: {
    msg_cs_modify: 'CS FAQ タイプが修正されました',
    msg_cs_register: 'CS FAQ タイプが登録されました',
    cs_type: 'CS FAQ タイプ名',
    cs_type_name: 'CS FAQ タイプ名',
  },
  contract_nav: {
    contract_catalog: '設定',
    contract_agreement_list: '約定履歴',
  },
  contract_document_info: {
    document_type: '文書タイプ',
    main_locale: '主 ロケール',
    name: '名前',
    title: 'タイトル',
    info: '説明',
    contract_language: '契約言語',
    master_locale: '主 ロケール者',
    msg_master_locale:
      "に対する契約文書言語が登録されていません。'追加' ボタンをクリックし登録を完了してください。登録しない場合今後お客様との法的紛争が発生する可能性があることをお知らせします。",
    locale: 'ロケール',
    content_write: '内容 作成/添付',
    select: '選択',
    msg_contract_document_register_no: '登録された契約文書言語がありません。',
  },
  brokerage_share_list: {
    seq: '仲介店持分固有番号',
    amount: '手当金額',
    asset_code: '資産コード',
    asset_seq: '資産固有番号',
    asset_title: '資産名',
    base_amount: '元金額',
    base_amount_target: '元金額対象',
    benefactor_email_address: '施益者Eメールアドレス',
    benefactor_member_seq: '施益者会員固有番号',
    benefactor_type: '施益者タイプ',
    benefactor_user_id: '施益者使用者ID',
    benefactor_user_name: '施益者使用者名',
    beneficiary_email_address: '受益者Eメールアドレス',
    beneficiary_member_seq: '受益者会員固有番号',
    beneficiary_type: '受益者タイプ',
    beneficiary_user_id: '受益者使用者ID',
    beneficiary_user_name: '受益者使用者名',
    causer_email_address: '発生者Eメールアドレス',
    causer_seq: '発生者会員固有番号',
    causer_user_id: '発生者使用者ID',
    causer_user_name: '発生者　使用者名',
    log_beneficiary_seq: '手当発生　受益者固有番号',
    log_policy_seq: '手当発生適用政策固有番号',
    log_seq: '手当発生固有番号',
    policy_amount: '手当政策指定手当金額',
    policy_seq: '適用手当政策固有番号',
    policy_title: '適用手当政策名',
    target_action_type: '対象行動タイプ',
    target_seq: '対象固有番号',
    affiliate_log_benefactor_seq: '手当発生施益者固有番号',
    brokerage_seq: '仲介店固有番号',
    brokerage_title: '仲介店タイトル',
    inherited_amount: '被相続額',
    acquire_rate: '取得率',
    acquire_amount: '取得額',
    regdate: '登録日',
    shortcuts_today: '今日',
    shortcuts_yesterday: '昨日',
    shortcuts_thismonth: '今月',
    shortcuts_lastmonth: '先月',
    shortcuts_thisweek: '今週',
    shortcuts_lastweek: '先週',
    shortcuts_week: '最近 7日',
    shortcuts_month: '最近 30日',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    brokerage_catalog_share_list: '仲介店持分履歴{0}',
    search: '検索',
    use_statistics_exclude: '統計除外会員除外',
    member_is_alive: '脱退会員除外',
    target_action: '対象行動',
    all: '全体',
    target_action_seq: '対象行動固有番号',
    causer: '発生者',
    behavior_type: '行動タイプ',
    occurrence_date: '発生日',
    applied_policy_name: '適用政策名',
    benefactor: '施益者',
    allowance_assets: '手当資産',
    allowance_amount: '手当金額',
    number: '番号',
    brokerage_name: '仲介店名',
    msg_brokerage_catalog_share_list_no: '検索された仲介店持分履歴がありません。',
  },
  brokerage_nav: {
    brokerage_list: '仲介店リスト',
    brokerage_catalog: '仲介店情報',
    brokerage_catalog_relation_list: '関係図',
    brokerage_catalog_balance_list: '資産別残高',
    brokerage_catalog_share_list: '持分履歴',
    brokerage_catalog_adjust_list: '精算履歴',
  },
  brokerage_list: {
    seq: '仲介店固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    title: 'タイトル',
    identification_code: '識別コード',
    brokerage_type: '仲介店タイプ',
    regdate: '登録日',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    brokerage_list: '仲介店リスト{0}',
    brokerage_modify: '仲介店修正',
    brokerage_register: '仲介店登録',
    use_statistics_exclude: '統計除外会員除外',
    member_is_alive: '脱退会員除外',
    brokerage_register_new: '+ 最上位仲介店新規登録',
    brokerage_detail: '仲介店詳細',
    subpoint_registration: '下位店登録',
    msg_search_brokerage_no: '検索された仲介店がありません。',
  },
  brokerage_info: {
    msg_wantto_edit: '修正されますか？',
    msg_brokerage_register: '仲介店を登録されますか？',
    msg_brokerage_modify_success: '仲介店が成功的に修正されました。',
    msg_brokerage_register_success: '仲介店が成功的に登録されました。',
    brokerage_allowed_not: '下位仲介店登録不可',
    lowest_broker_type: '最下位仲介店タイプ',
    msg_cannot_be_designated: 'を持った仲介店を管理店に指定できません。',
    management: '管理店',
    title: 'タイトル',
    management_acquisition: '管理店取得率',
    target_id: '所有者ID',
    brokerage_number: '仲介店固有番号',
    taxpayer_number: '納税者番号',
    number: 'SSN, ITIN, マイナンバー番号及び事業者登録番号等',
    brokerage_type: '仲介店タイプ',
    phone_number: '電話番号',
    regdate: '登録日',
    unregistered: '(未登録)',
    address: '住所',
    brokerage_code: '仲介店識別コード',
  },
  brokerage_balance_list: {
    seq: '持分残高固有番号',
    brokerage_title: '仲介店タイトル',
    amount: '残高',
    total_amount: '累積金額',
    asset_title: '資産名',
    asset_code: '資産コード',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    equity_balances_list: '持分残高リスト',
    msg_adjust_warning: '精算処理は不可逆的です。実行されますか？',
    msg_balance_settlement_success: '持分残高精算処理されました。',
    equity_balance_asset: '資産別持分残高',
    adjust_success: '精算処理',
    msg_brokerag_balance_no: '検索された仲介店持分残高がありません。',
    equity_settlement_processing: '持分精算処理',
    msg_account_select: '口座を選択してください。',
    msg_account_select_no: '精算可能口座が存在していません。',
    execution: '実行',
    brokerage_balance_list:
      '{0}仲介店の {1} 持分 {2} 全額を下の口座に精算処理',
  },
  brokerage_adjust_list: {
    seq: '持分残高固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    amount: '残高',
    total_amount: '累積金額',
    regdate: '最初支給日',
    asset_title: '資産名',
    asset_code: '資産コード',
    msg_excel_warning:
      'エクセルダウンロード時、データの量が膨大な場合、サーバーの過負荷及びブラウザー作動中止現象が発生する場合があります。実行されますか？',
    use_statistics_exclude: '統計除外会員除外',
    member_is_alive: '脱退会員除外',
    share_settlement_list: '持分精算履歴',
    title: '仲介店タイトル',
    settlement_amount: '精算金額',
    account_number: '口座番号',
    regday: '登録日',
    msg_search_settlement_history_no: '検索された仲介店精算履歴がありません。',
    share_settlement_history: '持分精算履歴{0}',
  },
  asset_withdraw_fee: {
    order: '順序',
    commission: '手数料',
    withdrawal_commission_same: '出金口座と手数料納付口座同一',
    fee_payment_account_can: '手数料納付口座別途指定可能',
    msg_asset_withdrawal_fee_no: '登録された資産出金手数料がありません。',
  },
  asset_info: {
    withdrawal_fee_usage: '出金手数料使用',
    msg_withdrawal_fee_done: "'出金手数料' タップで詳細設定を完了してください。",
    withdrawal_fee: '出金手数料',
  },
  affiliate_policy_info: {
    msg_allowance_policy_modify: '手当政策が修正されました。',
    msg_allowance_policy_register: '手当政策が登録されました。',
    title: 'タイトル',
    global_coverage: '全域専用',
    apply_no: '適用しない',
    apply_ok: '適用する',
    target_action: '対象行動',
    select: '選択',
    output_order: '出力順序',
    causer_condition: '発生者条件',
    action_condition: '対象行動条件',
    beneficiary: '受益者',
  },
  affiliate_policy_causer_condition: {
    order: '順序',
    condition_satisfied: '下の条件を全て満たさなければならない',
    msg_register_occurrence_target_no: '登録された発生者条件がありません。',
  },
  affiliate_policy_beneficiary: {
    allowance_policy_beneficiary: '手当政策受益者',
    output_order: '出力順序',
    beneficiary_type: '受益者タイプ',
    beneficiary: '受益者',
    member_unique_number: '会員固有番号が',
    relationship_with_originator: '発生者との推薦関係の深さが',
    msg_allowance_policy_no: '登録された手当政策受益者がいません。',
    allowance_policy_modify: '手当政策受益者修正',
    allowance_policy_register: '手当政策受益者登録',
  },
  affiliate_policy_beneficiary_info: {
    msg_allowance_policy_modify: '手当政策受益者が修正されました。',
    msg_allowance_policy_register: '手当政策受益者が登録されました。',
    beneficiary_type: '受益者タイプ',
    member_unique_number: '会員固有番号',
    referral_depth: '推薦関係深さ',
    output_order: '出力順序',
    condition: '条件',
    benefit: '施益者',
  },
  affiliate_policy_beneficiary_condition: {
    order: '順序',
    condition_satisfied: '下の条件を全て満たさなければならない',
    msg_allowance_policy_no: '登録された手当政策受益者条件がありません。',
  },
  affiliate_policy_benefactor: {
    order: '順序',
    benefit: '施益者',
    benefit_type: '施益者タイプ',
    msg_allowance_policy_no: '登録された手当政策受益者別施益者がいません。',
  },
  affiliate_policy_action_condition: {
    order: '順序',
    condition_satisfied: '下の条件を全て満たさなければならない',
    msg_behavior_conditions: '登録された行動条件がありません。',
  },
  affiliate_log_list: {
    search: '検索',
    use_statistics_exclude: '統計除外会員除外',
    member_is_alive: '脱退会員除外',
    target_action: '対象行動',
    all: '全体',
    target_seq: '対象行動固有番号',
    payment_history: '手当発生履歴',
    easy_info: '簡単な説明を見る',
    occurrence_target: '発生者',
    behavior_type: '行動タイプ',
    target_unique_number: '対象固有番号',
    occurrence_date: '発生日',
    applied_policy_name: '適用政策名',
    beneficiary_type: '受益者タイプ',
    beneficiary: '受益者',
    number: '番号',
    benefit_type: '施益者タイプ',
    principal_amount_target: '元金額対象',
    allowance_assets: '手当資産',
    benefit: '施益者',
    principal_amount: '元金額',
    allowance_amount: '手当金額',
    msg_allowance_amount_no: '検索された手当発生履歴がありません。',
    occurrence_info: '発生情報',
    policy_info: '政策情報',
    beneficiary_info: '受益者情報',
    benefit_info: '施益情報',
  },
  affiliate_balance_list: {
    seq: '手当残高固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    amount: '残高',
    total_amount: '累積金額',
    asset_title: '資産名',
    asset_code: '資産コード',
    allowance_balances_list: '手当残高リスト {0}',
    msg_adjust_to_account: '{0}様の {1} 手当 {2} 全額を下の口座に精算処理',
  },
  affiliate_adjust_list: {
    seq: '手当残高固有番号',
    member_seq: '会員固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    amount: '残高',
    total_amount: '累積金額',
    regdate: '最初支給日',
    asset_title: '資産名',
    asset_code: '資産コード',
    allowance_settlement_list: '手当精算履歴{0}',
  },
  activity_log_list: {
    seq: 'ログ固有番号',
    eventer_seq: '実行者固有番号',
    description: 'ログ説明',
    ipaddress: 'IP アドレス',
    user_agent: '端末情報',
    default_locale: '基本ロケール',
    regdate: '登録日',
    logset_seq: 'ログ括り固有番号',
    target: '対象',
    target_seq: '対象固有番号',
    reference: '参照',
    reference_seq: '参照固有番号',
    logset_description: 'ログ括り説明',
    user_id: '使用者ID',
    email_address: 'Eメールアドレス',
    user_name: '名前',
    logset_description_replaced: 'ログ括り説明置換値',
    description_replaced: 'ログ説明置換値',
    activity_history: '活動履歴{0}',
  },
  account_transfer_list: {
    seq: '振込申請固有番号',
    asset_seq: '資産固有番号',
    from_seq: '出金口座固有番号',
    to_seq: '入金口座固有番号',
    amount: '振込金額',
    from_member_seq: '出金口座会員固有番号',
    to_member_seq: '入金口座会員固有番号',
    from_account_number: '出金口座番号',
    to_account_number: '入金口座番号',
    from_user_name: '出金口座会員名',
    to_user_name: '入金口座会員名',
    asset_title: '資産名',
    asset_code: '資産コード',
    regdate: '登録日',
    from_user_id: '出金口座会員ID',
    from_email_address: '出金口座会員Eメール',
    to_user_id: '入金口座会員ID',
    to_email_address: '入金口座会員Eメール',
    transfer_request_list: '振込申請履歴{0}',
  },
  account_list: {
    seq: '口座固有番号',
    member_seq: '会員固有番号',
    address_seq: '入金専用アドレス固有番号',
    user_id: 'ID',
    user_name: '名前',
    email_address: 'Eメールアドレス',
    title: '口座名',
    account_number: '口座番号',
    balance: '残高',
    status: '状態',
    regdate: '開設日',
    address: '入金専用アドレス',
    asset_title: '資産名',
    asset_code: '資産コード',
    holding_balance: '停止金額',
    account_history: '口座リスト{0}',
  },
  account_balance_log_list: {
    seq: 'ログ固有番号',
    eventer_seq: '実行者固有番号',
    description: 'ログ説明',
    ipaddress: 'IP アドレス',
    user_agent: '端末情報',
    default_locale: '基本ロケール',
    regdate: '登録日',
    logset_seq: 'ログ括り固有番号',
    target: '対象',
    target_seq: '対象固有番号',
    reference: '参照',
    reference_seq: '参照固有番号',
    logset_description: 'ログ括り説明',
    user_id: '使用者ID',
    email_address: 'Eメールアドレス',
    user_name: '名前',
    before: '以前値',
    after: '以降値',
    logset_description_replaced: 'ログ括り説明置換値',
    description_replaced: 'ログ説明置換値',
    excel_filename: '残高変動履歴 {0}',
  },
}
